// extracted by mini-css-extract-plugin
export default {"wrapper":"Video_wrapper__DVgpQ","video":"Video_video__KEZil","duration":"Video_duration__J79Xz"};